import React, { useContext } from 'react'
import { FormDetailsPayload } from '../form/__new_form/types/BaseFormProps'

export const FormProvider = React.createContext<FormDetailsPayload>(null)

export function useFormPayload() {
  return useContext(FormProvider)
}
